import { API as e, Resource as t } from "@coveo/platform-client";
//#region src/resources/SourcesInternalResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/rest/organizations/${e.orgPlaceholder}/sources`;
	}
	listAll() {
		return this.api.get(`${n.baseUrl}/basic/all`);
	}
	listSourcesByProjectId(e, t = {}) {
		return this.api.get(this.buildPath(`${n.baseUrl}/pages/project`, {
			...t,
			projectId: e
		}));
	}
	async getSalesforceObjectForSource(e, t) {
		let r = await this.api.get(this.buildPath(`${n.baseUrl}/${e}/configuration/salesforce/objects/${encodeURIComponent(t)}`));
		return {
			...r,
			fields: this.sortObjectFields(r.fields),
			relationships: this.sortObjectRelationships(r.relationships)
		};
	}
	async getSalesforceObjectRelationshipForSource(e, t, r) {
		let i = await this.api.get(this.buildPath(`${n.baseUrl}/${e}/configuration/salesforce/objects/${encodeURIComponent(t)}/${encodeURIComponent(r)}`));
		return {
			...i,
			fields: this.sortObjectFields(i.fields)
		};
	}
	listFieldsByProjectId(e, t = {}) {
		return this.api.get(this.buildPath(`${n.baseUrl}/page/fields`, {
			...t,
			projectId: e
		}));
	}
	getAllFieldsForSource(e, t = !0) {
		return this.api.get(this.buildPath(`${n.baseUrl}/fields`, {
			sourceId: e,
			includeMappings: t
		}));
	}
	sortObjectFields(e) {
		return e.slice().sort((e, t) => Number(t.indexed) - Number(e.indexed) || e.label.localeCompare(t.label));
	}
	sortObjectRelationships(e) {
		return e.slice().sort((e, t) => e.relationshipName.localeCompare(t.relationshipName)).map((e) => ({
			...e,
			...e.fields && { fields: this.sortObjectFields(e.fields) }
		}));
	}
};
//#endregion
export { n as SourcesInternalResource };

//# sourceMappingURL=SourcesInternalResource.js.map